import request from "axios";
import types from "./types";

export function toggleEditing(sectionId, bool) {
  return {
    type: types.TOGGLE_EDIT,
    sectionId,
    bool,
  };
}

export function updateBody(sectionId, content) {
  return {
    type: types.UPDATE_BODY,
    sectionId,
    content,
  };
}

export function saveSection(section, body) {
  return (dispatch) => {
    const token = document.querySelector("meta[name='csrf-token']").content;

    const params = {
      url: `/sections/${section.get("id")}`,
      method: "PUT",
      data: {
        section: {
          body: body,
        },
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
      },
    };

    request(params)
      .then((response) => {
        dispatch({
          type: types.UPDATE_BODY,
          sectionId: section.get("id"),
          content: body,
        });

        dispatch({
          type: types.TOGGLE_EDIT,
          sectionId: section.get("id"),
          bool: false,
        });
      })
      .catch((error) => {
        throw error;
      });
  };
}
